import React from 'react';
import { InfoContainer } from '@lmn/design-system';
import { useTranslation } from '@/app/components/translations/Translation';
import { IconCircleInfoSolid } from '@/app/common/icons/libraryIcons';

const MessageIcon = () => <IconCircleInfoSolid size={16} />;

type GroupLuggageMessageProps = {
  groupLuggagePieces: number;
} & React.HTMLAttributes<HTMLElement>;

export default function GroupLuggageMessage({ groupLuggagePieces, ...props }: GroupLuggageMessageProps) {
  const { t } = useTranslation();
  const label =
    groupLuggagePieces > 1
      ? t('vacation.select.cc.luggage.checked.already_included.plural', { num: groupLuggagePieces.toString() })
      : t('vacation.select.cc.luggage.checked.already_included');
  if (!label) return null;

  return (
    <InfoContainer
      icon={MessageIcon}
      message={label}
      type="specific"
      hasBorder={false}
      className="keep-visible"
      {...props}
    />
  );
}
